angular.module('storefrontApp')
    .controller('searchBarController', [
        '$scope',
        '$timeout',
        '$window',
        'catalogService',
        function (
            $scope,
            $timeout,
            $window,
            catalogService,
        ) {
            let timer;

            $scope.query = $window.searchQuery;

            $scope.getSuggestions = function () {
                if (!$scope.query) {
                    return;
                }

                $timeout.cancel(timer);

                timer = $timeout(function () {
                    $scope.searching = true;
                    $scope.productSuggestions = [];

                    const searchCriteria = {
                        keyword: $scope.query,
                        start: 0,
                        pageSize: $window.suggestionsLimit,
                        isFuzzySearch: true,
                    };

                    catalogService.search(searchCriteria)
                        .then(({ data: { products } }) => {
                            $scope.productSuggestions = products;
                            $scope.searching = false;
                        });
                }, 300);
            };
        }]);
